var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgGn = function SvgGn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M0 0h213.333v480H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M213.333 0h213.333v480H213.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#090",
    d: "M426.666 0H640v480H426.665z"
  }))));
};
export default __webpack_public_path__ + "assets/798b298a1fcd901a639bcf3157169871.svg";
export { SvgGn as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/gn.svg